import { useEffect, useRef, useState } from 'react';

/**
 * Tracks the rendered width of a chart container for responsive SVG layouts.
 */
export function useChartContainerWidth(minWidth = 640, fallbackWidth = 1100) {
  const ref = useRef(null);
  const [width, setWidth] = useState(fallbackWidth);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const measure = () => {
      const next = Math.floor(node.getBoundingClientRect().width);
      if (next > 0) {
        setWidth(Math.max(minWidth, next));
      }
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    window.addEventListener('resize', measure);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return [ref, width];
}
